/** Route base → Mixpanel `app` label (the names each app used before it ran inside the host). */
const APP_BY_ROUTE_BASE: ReadonlyArray<readonly [string, string]> = [
  ['/onboarding', 'sign_up_flow'],
  ['/dashboard', 'investor_dashboard'],
  ['/admin', 'venture_dashboard'],
  ['/invest', 'invest_in_sto'],
]

/** Which app a host URL belongs to; everything outside the remote routes is `homepage`. */
export function analyticsAppForPath(pathname: string): string {
  for (const [base, app] of APP_BY_ROUTE_BASE) {
    if (pathname === base || pathname.startsWith(`${base}/`)) return app
  }
  return 'homepage'
}
